import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { DeviationViewMode } from '@wix/da-react-context/pkg/publicSession';
import { PapiDeviation, PapiCommentThread } from '@wix/da-papi-types';
import { Stash } from './types';
import { PapiGruser } from '@wix/da-gruser-shared/pkg/types/papi';

export const loadDeviation = createAction(
  `${actionKey}.LOAD_DEVIATION`,
  (deviation: PapiDeviation) => ({ deviation })
);
export const initDeviationPage = createAction(
  `${actionKey}.INIT_DEVIATION`,
  (
    deviation: PapiDeviation,
    comments: PapiCommentThread,
    biMetadata,
    gruser: PapiGruser | undefined
  ) => ({
    deviation,
    comments,
    biMetadata,
    gruser,
  })
);

export const initStash = createAction(
  `${actionKey}.INIT_STASH`,
  (stash: Stash) => ({
    stash,
  })
);

export const fullscreenEntered = createAction(
  `${actionKey}.VIEW.FULLSCREEN_ENTERED`,
  (deviation: PapiDeviation) => ({ deviation })
);
export const fullscreenExited = createAction(
  `${actionKey}.VIEW.FULLSCREEN_EXITED`,
  (deviation: PapiDeviation) => ({ deviation })
);

export const requestChangeViewMode = createAction(
  `${actionKey}.VIEW.REQUEST_CHANGE_VIEW_MODE`,
  (viewMode: DeviationViewMode, deviation: PapiDeviation) => ({
    viewMode,
    deviation,
  })
);

export const requestToggleTheaterView = (deviation: PapiDeviation) =>
  requestChangeViewMode(DeviationViewMode.Theater, deviation);
export const requestToggleFullscreenView = (deviation: PapiDeviation) =>
  requestChangeViewMode(DeviationViewMode.Fullscreen, deviation);

export const setScreenSize = createAction(
  `${actionKey}.VIEW.SET_SCREEN_SIZE`,
  (width: number, height: number) => ({ width, height })
);

export const focusCommentEditor = createAction(
  `${actionKey}.FOCUS_COMMENT_EDITOR`,
  (deviation: PapiDeviation) => ({
    deviation,
  })
);

export const postPublishTrigger = createAction(
  `${actionKey}.POST_PUBLISH_TRIGGER`,
  () => ({})
);
